import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);


import Dashboard from '../components/page/Dashboard.vue';
import User from '../components/page/sys/user/User.vue';
import Menu from '../components/page/sys/menu/Menu.vue';
import Role from '../components/page/sys/role/Role.vue';
import Dept from '../components/page/sys/dept/Dept.vue';
import Dict from '../components/page/sys/dict/Dict.vue';
import Log from '../components/page/sys/log/Log.vue';
import StudentManage from '../components/page/sys/student/Student.vue';
import TeacherManage from '../components/page/sys/teacher/Teacher.vue';
import ParentManage from '../components/page/sys/parent/Parent.vue';
import CardManage from '../components/page/sys/card/Card.vue';
import Post from '../components/page/base/post/Post.vue';
import DeviceSys from '../components/page/device/devicesys/DeviceSys.vue';
import Device from '../components/page/device/device/Device.vue';
import Traffic from '../components/page/device/traffic/Traffic.vue';
import ClassHours from '../components/page/base/classHours/ClassHours.vue';
import Alarm from '../components/page/alarm/Alarm.vue';
import Name from '../components/page/set/name/Name.vue';
import ClassroomTime from '../components/page/set/classroomtime/ClassroomTime.vue';
import GateStrategy from '../components/page/set/gate/GateStrategy.vue';
import CanteenStrategy from '../components/page/set/gate/CanteenStrategy.vue';
import TeacherTime from '../components/page/set/tearcher/TeacherTime.vue';
import Setparam from '../components/page/set/setparam/Setparam.vue';
import StudentAbsence from '../components/page/report/StudentAbsence.vue'
import TeacherCard from '../components/page/report/TeacherCard.vue'
import Visitor from '../components/page/report/Visitor.vue'
import Holidays from '../components/page/attendance/holidays/Holidays.vue'
import Classes from '../components/page/attendance/classes/Classes.vue'
import Group from '../components/page/attendance/group/Group.vue'
import ClassVideo from '../components/page/class/ClassVideo.vue'
import AttendanceConfig from '../components/page/hostel/AttendanceConfig.vue'
import BoarderWechatNotice from '../components/page/hostel/notice/BoarderWechatNotice.vue'
import BoarderAttendance from '../components/page/hostel/boarderAttendance.vue'
import BoarderAttendanceCount from '../components/page/hostel/boarderAttendanceCount.vue'
import FlowDesign from '../components/page/flow/design/FlowDesign.vue'
import Face from '../components/page/set/face/Face.vue'
import SetBindDevice from '../components/page/set/deviceBind/SetBindDevice.vue'
import BorrowBookNumber from '../components/page/library/BorrowBookNumber.vue'
import SetVisitor from '../components/page/set/visitor/SetVisitor.vue'
import OnelevelService from '../components/page/sys/onelevel/OnelevelService.vue'

// 考勤统计
import Student from '../components/page/count/student/StudentMain.vue'
import TeacherCount from '../components/page/count/TeacherCount.vue'
import TeacherDay from '../components/page/count/TeacherDay.vue'
import Levae from '../components/page/count/LevaeMain.vue'

// 评价系统
import ModuleConfig from '../components/page/mobileset/moduleconfig/ModuleConfig.vue'
import EvaluateTypeMain from '../components/page/mobileset/evaluate/EvaluateTypeMain.vue'
import EvaluateMain from '../components/page/mobileset/evaluate/EvaluateMain.vue'
import ClassEvaluateMain from '../components/page/mobileset/classset/ClassEvaluateMain.vue'
import EvaluateRecord from '../components/page/mobileset/evaluate/EvaluateRecord.vue'
import ParamSet from '../components/page/mobileset/ParamSet.vue'
import EvaluateCheckMain from '../components/page/mobileset/evaluate/EvaluateCheckMain.vue'

// 家校互通
import NoticeRelease from '../components/page/notice/NoticeRelease.vue'
import PlatformNotice from '../components/page/notice/PlatformNotice.vue'
import PlatformMessage from '../components/page/hsc/PlatformMessage.vue'
import CallDetail from '../components/page/hsc/CallDetail.vue'
import MemberPrivilege from '../components/page/member/privilege/Privilege.vue'
import MemberProduct from '../components/page/member/product/Product.vue'
import MemberSet from '../components/page/member/set/MemberSet.vue'
import MemberOrder from '../components/page/member/order/MemberOrder.vue'
import ScoreList from '../components/page/score/ScoreList.vue'
import Task from '../components/page/mobileset/task/Task.vue'

// 实践评价
import TaskList from '../components/page/task/TaskList.vue'
// 打卡作业设置
import setClockinMain from '../components/page/task/setClockinMain.vue'

// 积分商城
import CommodityList from '../components/page/shop/wares/CommodityList.vue'
import CommodityOrder from '../components/page/shop/order/CommodityOrder.vue'
import ExchangeGold from '../components/page/shop/exchange/ExchangeGold.vue'
import ClassroomPrize from '../components/page/shop/prize/list.vue'
import coinMain from '../components/page/schoolCoin/coinMain.vue'

// 应用管理
import ApplyManage from '../components/page/apply/ApplyManage.vue'
import ApplyAndroidManage from '../components/page/apply/ApplyAndroidManage.vue'

// 第三方企业应用管理
import ThirdApplyManage from '../components/page/apply/thirdApply/index.vue'

// 教职评价
import TeacherEvaluateMain from '../components/page/mobileset/teacher/TeacherEvaluateMain.vue'
import TeacherEvaluateCheck from '../components/page/mobileset/evaluate/TeacherEvaluateCheck.vue'

// 教师绩效
import TemplateConfig from '../components/page/teacher/config/TemplateConfig.vue'

// 评价审核人配置
// import EvaluateCheckuserSet from '../components/page/mobileset/checkUserSet/EvaluateCheckuserSet.vue'

// 五育报告
import ComplexReport from '../components/page/complexReport/complexMain.vue'

// 教职绩效
import BasisMain from '../components/page/teacherAssess/basis/BasisMain.vue'
import TeacherTemplate from '../components/page/teacherAssess/template/TeacherTemplate.vue'
import TeacherAssess from '../components/page/teacherAssess/teacherAssess/TeacherAssess.vue'
import TeacherAssessProcess from '../components/page/teacherAssess/teacherAssess/TeacherAssessProcess.vue'

// 假期管理
import LeaveRules from '../components/page/vacation/leaveRules/List.vue'
import VacationSurplus from '../components/page/vacation/vacationSurplus/List.vue'

// 设置导师班
import setMentorClass from '../components/page/set/setMentorClass/list.vue'

// 课堂兑换记录
import exchangePrizeRecord from '../components/page/shop/exchangePrize/list.vue'

// 评价误删恢复
import evaluateHistory from '../components/page/mobileset/evaluate/EvaluateHistory.vue'

// 评价系统（归档）
import evaluateArchiveMain from '../components/page/mobileset/evaluateArchive/EvaluateMain.vue'

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: { title: '自述文件' },
            children:[
                {
                    path: '/dashboard',
                    component: Dashboard,
                    meta: { title: '系统首页' ,noCache:false}
                },
                {
                    path: '/sys/user',
                    component:User,
                    name: 'User',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/student',
                    component: StudentManage,
                    name: 'StudentManage',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/teacher',
                    component: TeacherManage,
                    name: 'TeacherManage',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/parent',
                    component: ParentManage,
                    name: 'ParentManage',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/card',
                    component: CardManage,
                    name: 'CardManage',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/menu',
                    component: Menu,
                    name: 'Menu',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/role',
                    component: Role,
                    name: 'Role',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/dept',
                    component: Dept,
                    name: 'Dept',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/dict',
                    component: Dict,
                    name: 'Dict',
                    meta: {noCache:false}
                },
                {
                    path: '/sys/log',
                    component: Log,
                    name: 'Log',
                    meta: {noCache:false}
                },
                {
                    path: '/base/post',
                    component: Post,
                    name: 'Post',
                    meta: {noCache:false}
                },
                {
                    path: '/base/classHours',
                    component: ClassHours,
                    name: 'ClassHours',
                    meta: {noCache:false}
                },
                {
                    path: '/business/deviceSys',
                    component: DeviceSys,
                    name: 'DeviceSys',
                    meta: {noCache:false}
                },
                {
                    path: '/business/device',
                    component: Device,
                    name: 'Device',
                    meta: {noCache:false}
                },
                {
                    path: '/business/trafficRecord',
                    component: Traffic,
                    name: 'Traffic',
                    meta: {noCache:false}
                },
                {
                    path: '/business/alarmManage',
                    component: Alarm,
                    name: 'Alarm',
                    meta: {noCache:false}
                },
                {
                    path: '/business/nameList',
                    component: Name,
                    name: 'Name',
                    meta: {noCache:false}
                },
                {
                    path: '/business/seclassroomTime',
                    component: ClassroomTime,
                    name: 'ClassroomTime',
                    meta: {noCache:false}
                },
                {
                    path: '/business/setMentorClass',
                    component: setMentorClass,
                    name: 'setMentorClass',
                    meta: {noCache:false}
                },
                {
                    path: '/business/setGateStrategy',
                    component: GateStrategy,
                    name: 'GateStrategy',
                    meta: {noCache:false}
                },
                {
                    path: '/business/setCanteenStrategy',
                    component: CanteenStrategy,
                    name: 'CanteenStrategy',
                    meta: {noCache:false}
                },
                {
                    path: '/business/setTeacherTime',
                    component: TeacherTime,
                    name: 'TeacherTime',
                    meta: {noCache:false}
                },{
                    path: '/business/setParam',
                    component: Setparam,
                    name: 'Setparam',
                    meta: {noCache:false}
                },{
                    path: '/business/face',
                    component: Face,
                    name: 'Face',
                    meta: {noCache:false}
                },{
                    path: '/business/setVisitor',
                    component: SetVisitor,
                    name: 'SetVisitor',
                    meta: {noCache:false}
                },{
                    path: '/business/studentAbsenceRecord',
                    component: StudentAbsence,
                    name: 'StudentAbsence',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherCardRecord',
                    component: TeacherCard,
                    name: 'TeacherCard',
                    meta: {noCache:false}
                },{
                    path: '/business/visitor',
                    component: Visitor,
                    name: 'Visitor',
                    meta: {noCache:false}
                },{
                    path: '/business/legalHolidays',
                    component: Holidays,
                    name: 'Holidays',
                    meta: {noCache:false}
                },{
                    path: '/business/classes',
                    component: Classes,
                    name: 'Classes',
                    meta: {noCache:false}
                },{
                    path: '/business/attendaceGroup',
                    component: Group,
                    name: 'Group',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherDayAttendance',
                    component: TeacherDay,
                    name: 'TeacherDay',
                    meta: {noCache:false}
                },{
                    path: '/business/studentAttendance',
                    component: Student,
                    name: 'Student',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherCount',
                    component: TeacherCount,
                    name: 'TeacherCount',
                    meta: {noCache:false}
                },{
                    path: '/business/classroomVideo',
                    component: ClassVideo,
                    name: 'ClassVideo',
                    meta: {noCache:false}
                },{
                    path: '/business/noticeRelease',
                    component: NoticeRelease,
                    name: 'NoticeRelease',
                    meta: {noCache:false}
                },{
                    path: '/business/platformNotice',
                    component: PlatformNotice,
                    name: 'PlatformNotice',
                    meta: {noCache:false}
                },{
                    path: '/business/platformMessage',
                    component: PlatformMessage,
                    name: 'PlatformMessage',
                    meta: {noCache:false}
                },{
                    path: '/business/callDetail',
                    component: CallDetail,
                    name: 'CallDetail',
                    meta: {noCache:false}
                },{
                    path: '/business/memberPrivilege',
                    component: MemberPrivilege,
                    name: 'MemberPrivilege',
                    meta: {noCache:false}
                },{
                    path: '/business/memberProduct',
                    component: MemberProduct,
                    name: 'MemberProduct',
                    meta: {noCache:false}
                },{
                    path: '/business/memberSet',
                    component: MemberSet,
                    name: 'MemberSet',
                    meta: {noCache:false}
                },{
                    path: '/business/memberOrder',
                    component: MemberOrder,
                    name: 'MemberOrder',
                    meta: {noCache:false}
                },{
                    path: '/business/attendanceConfig',
                    component: AttendanceConfig,
                    name: 'AttendanceConfig',
                    meta: {noCache:false}
                },{
                    path: '/business/boarderWechatNotice',
                    component: BoarderWechatNotice,
                    name: 'BoarderWechatNotice',
                    meta: {noCache:false}
                },{
                    path: '/business/boarderAttendance',
                    component: BoarderAttendance,
                    name: 'boarderAttendance',
                    meta: {noCache:false}
                },{
                    path: '/business/boarderAttendanceCount',
                    component: BoarderAttendanceCount,
                    name: 'boarderAttendanceCount',
                    meta: {noCache:false}
                },{
                    path: '/business/flowDesign',
                    component: FlowDesign,
                    name: 'FlowDesign',
                    meta: {noCache:false}
                },{
                    path: '/business/setBindDevice',
                    component: SetBindDevice,
                    name: 'SetBindDevice',
                    meta: {noCache:false}
                },{
                    path: '/user/listUserBookNumber',
                    component: BorrowBookNumber,
                    name: 'BorrowBookNumber',
                    meta: {noCache:false}
                },{
                    path: '/business/moduleConfig',
                    component: ModuleConfig,
                    name: 'ModuleConfig',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateType',
                    component: EvaluateTypeMain,
                    name: 'EvaluateTypeMain',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateMain',
                    component: EvaluateMain,
                    name: 'EvaluateMain',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateRecord',
                    component: EvaluateRecord,
                    name: 'EvaluateRecord',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateCheck',
                    component: EvaluateCheckMain,
                    name: 'EvaluateCheckMain',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherEvaluateCheck',
                    component: TeacherEvaluateCheck,
                    name: 'TeacherEvaluateCheck',
                    meta: {noCache:false}
                },{
                    path: '/business/classEvaluateType',
                    component: ClassEvaluateMain,
                    name: 'ClassEvaluateMain',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherEvaluateType',
                    component: TeacherEvaluateMain,
                    name: 'TeacherEvaluateMain',
                    meta: {noCache:false}
                },{
                    path: '/business/scoreList',
                    component: ScoreList,
                    name: 'ScoreList',
                    meta: {noCache:false}
                },
                {
                    path: '/business/paramSet',
                    component: ParamSet,
                    name: 'ParamSet',
                    meta: {noCache:false}
                },
                {
                    path: '/business/taskList',
                    component: TaskList,
                    name: 'TaskList',
                    meta: {noCache:false}
                },
                {
                    path: '/business/setClockinMain',
                    component: setClockinMain,
                    name: 'setClockinMain',
                    meta: {noCache:false}
                },
                {
                    path: '/business/myTask',
                    component: Task,
                    name: 'Task',
                    meta: {noCache:false}
                },{
                    path: '/business/commodityList',
                    component: CommodityList,
                    name: 'CommodityList',
                    meta: {noCache:false}
                },{
                    path: '/business/commodityOrder',
                    component: CommodityOrder,
                    name: 'CommodityOrder',
                    meta: {noCache:false}
                },{
                    path: '/business/commodityIntegralExchangeGold',
                    component: ExchangeGold,
                    name: 'ExchangeGold',
                    meta: {noCache:false}
                },{
                    path: '/business/classroomPrize',
                    component: ClassroomPrize,
                    name: 'ClassroomPrize',
                    meta: {noCache:false}
                },{
                    path: '/business/onelevelServiceUrl',
                    component: OnelevelService,
                    name: 'OnelevelService',
                    meta: {noCache:false}
                },{
                    path: '/business/applyManage',
                    component: ApplyManage,
                    name: 'ApplyManage',
                    meta: {noCache:false}
                },{
                    path: '/business/applyAndroidManage',
                    component: ApplyAndroidManage,
                    name: 'ApplyAndroidManage',
                    meta: {noCache:false}
                },{
                    path: '/business/thirdApplyManage',
                    component: ThirdApplyManage,
                    name: 'ThirdApplyManage',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherTemplateConfig',
                    component: TemplateConfig,
                    name: 'TemplateConfig',
                    meta: {noCache:false}
                },
                {
                    path: '/business/studentComprehensiveReport',
                    component: ComplexReport,
                    name: 'ComplexReport',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherAssessBasisConfig',
                    component: BasisMain,
                    name: 'BasisMain',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherTemplateManage',
                    component: TeacherTemplate,
                    name: 'TeacherTemplate',
                    meta: {noCache:false}
                },{
                    path: '/business/teacherAssess',
                    component: TeacherAssess,
                    name: 'TeacherAssess',
                    meta: {noCache:false}
                },{
                    path: '/business/TeacherAssessProcess',
                    component: TeacherAssessProcess,
                    name: 'TeacherAssessProcess',
                    meta: {noCache:false}
                },{
                    path: '/business/staffLeaveRules',
                    component: LeaveRules,
                    name: 'LeaveRules',
                    meta: {noCache:false}
                },{
                    path: '/business/staffVacationSurplus',
                    component: VacationSurplus,
                    name: 'VacationSurplus',
                    meta: {noCache:false}
                },{
                    path: '/business/leave',
                    component: Levae,
                    name: 'Levae',
                    meta: {noCache:false}
                },{
                    path: '/business/exchangePrizeRecord',
                    component: exchangePrizeRecord,
                    name: 'exchangePrizeRecord',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateHistory',
                    component: evaluateHistory,
                    name: 'evaluateHistory',
                    meta: {noCache:false}
                },{
                    path: '/business/evaluateArchiveMain',
                    component: evaluateArchiveMain,
                    name: 'evaluateArchiveMain',
                    meta: {noCache:false}
                },{
                    path: '/business/coinMain',
                    component: coinMain,
                    name: 'coinMain',
                    meta: {noCache:false}
                }
            ]
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/Login.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js